import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarVirtualTextSearch_vue_vue_type_script_setup_true_lang_default from "./ScalarVirtualTextSearch.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                            */
//#region src/components/ScalarVirtualText/ScalarVirtualTextSearch.vue
var ScalarVirtualTextSearch_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarVirtualTextSearch_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-b843dc7d"]]);
//#endregion
export { ScalarVirtualTextSearch_default as default };

//# sourceMappingURL=ScalarVirtualTextSearch.vue.js.map